import React from "react";
import { Box, Card, Typography } from "@mui/material";

import {
    ComposableMap,
    Geographies,
    Geography,
    Tooltip
} from "react-simple-maps";
import MapChart from "../../assets/Map/02.01.2026_18.36.43_REC.png"

// USA states TopoJSON URL
const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

// Map state FIPS → Code mapping
const stateCodes = {
    1: "AL", 2: "AK", 4: "AZ", 5: "AR", 6: "CA",
    8: "CO", 9: "CT", 10: "DE", 12: "FL", 13: "GA",
    16: "ID", 17: "IL", 18: "IN", 19: "IA", 20: "KS",
    21: "KY", 22: "LA", 23: "ME", 24: "MD", 25: "MA",
    26: "MI", 27: "MN", 28: "MS", 29: "MO", 30: "MT",
    31: "NE", 32: "NV", 33: "NH", 34: "NJ", 35: "NM",
    36: "NY", 37: "NC", 38: "ND", 39: "OH", 40: "OK",
    41: "OR", 42: "PA", 44: "RI", 45: "SC", 46: "SD",
    47: "TN", 48: "TX", 49: "UT", 50: "VT", 51: "VA",
    53: "WA", 54: "WV", 55: "WI", 56: "WY"
};
// EXACT COLOR RANGE (from your image)
const getColor = (value) => {
    if (value <= 10) return "#E8F3E2";     // $0–$10M
    if (value <= 30) return "#D0EBBE";     // $10–$30M
    if (value <= 60) return "#B7E29A";     // $30–$60M
    if (value <= 100) return "#99D56F";    // $60–$100M
    if (value <= 150) return "#6BB542";    // $100–$150M
    return "#4C8C17";                       // $150M+
};


const Maps = ({ usaData, thickBorderStates, legendData, title }) => {
    return (
        <Card
            sx={{
                borderRadius: "12px !important",
                background: "#fff",
                border: "1px solid #e5e5e5",
                 boxShadow: "0px 1px 12px rgba(0, 0, 0, 0.1)",
                height: "100%",
                position: "relative",
                overflow: "visible",
            }}
        >
            {/* TITLE */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "12px",
                    right: "12px",
                    background: "#115f9c",
                    height: "36px",
                    borderRadius: "4px !important",
                    display: "flex",
                    alignItems: "center",
                    px: "12px",
                    color: "#fff",
                    fontSize: { xs: 12, sm: 12, md: 16 },
                    fontWeight: 200,
                    boxShadow:"0px 1px 16px rgba(128, 203, 255, 0.5)"
                }}
            >
                {title}
            </Box>

            {/* MAP */}
            <Box sx={{ p: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <ComposableMap
                    projection="geoAlbersUsa"
                    style={{ width: "100%", height: "100%" }}
                >
                    <Geographies geography={geoUrl}>
                        {({ geographies }) =>
                            geographies.map((geo) => {
                                const code = stateCodes[geo.id];
                                const value = usaData[code] || 0;
                                const isThick = thickBorderStates.includes(code);

                                return (
                                    <Geography
                                        key={geo.rsmKey}
                                        geography={geo}
                                        fill={getColor(value)}
                                        stroke="#000"
                                        strokeWidth={isThick ? 3.2 : 0.6}
                                        strokeLinejoin="round"
                                        strokeLinecap="round"
                                        style={{
                                            default: { outline: "none" },
                                            hover: { fill: "#1e8f1f", outline: "none" },
                                            pressed: { outline: "none" },
                                        }}
                                    />
                                );
                            })
                        }
                    </Geographies>
                </ComposableMap>
                {/* LEGEND */}
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: 3,
                        mt: 3,
                    }}
                >
                    {legendData.map((item, i) => (
                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    backgroundColor: item.color,
                                }}
                            />
                            <Typography sx={{ fontSize: 10,color: "#111111",fontWeight:200  }} >{item.label}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Card>
    );
};

export default Maps;
